import React, { useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchCSVDataset, resetCSVExport } from '../actions/csv_export'
import { EXPORT_VIEW_COMPLETE, EXPORT_VIEW_CURRENT } from '../config'
import CsvExportButton from './csv_export/csv_export_button'
import { useOnClickOutside } from '../utils/hooks'

const CSVExport = (props) => {
  const { isFetching, results, header, exporter, fetchCSVDataset, url, count, resetCSVExport } = props
  const [subMenu, setSubMenu] = useState('dropdown')
  const [csvButtonActive, setCsvButtonActive] = useState(false)
  const [ariaExpanded, setAriaExpanded] = useState(false)
  const [open, setOpen] = useState(false)
  const ref = useRef()

  useOnClickOutside(ref, () => {
    setSubMenu('btn-group')
    setAriaExpanded(false)
  })

  const handleExportClick = async (viewType) => {
    setSubMenu('btn-group')
    setAriaExpanded(false)
    setCsvButtonActive(false)
    if (viewType === EXPORT_VIEW_COMPLETE) {
      let exportAllUrl = url.substring(0, url.indexOf('?'))
      await fetchCSVDataset(exportAllUrl, count)
    } else {
      await fetchCSVDataset(url)
    }
    resetCSVExport()
  }

  const openSubMenu = (isOn) => {
    setOpen(!isOn)
    if (isOn) {
      setSubMenu('btn-group')
      setAriaExpanded(false)
      setCsvButtonActive(false)
    } else {
      setSubMenu('btn-group open')
      setAriaExpanded(true)
      setCsvButtonActive(true)
    }
    resetCSVExport()
  }
  return (
    <>
      <div className={subMenu + (open ? ' show' : '')} ref={ref}>
        <CsvExportButton
          exporter={exporter}
          header={header}
          isActive={csvButtonActive}
          isFetching={isFetching}
          results={results}
          handleMenuClick={() => openSubMenu(ariaExpanded)}
        />
        <ul
          style={{ minWidth: '100px', opacity: '0.75', left: '-70px' }}
          className={
            'dropdown-menu dropdown-menu dropdown-menu-end dropdown-menu-lg-start fadeIn' + (open ? ' show' : '')
          }
        >
          <li>
            <Button onClick={() => handleExportClick(EXPORT_VIEW_CURRENT)} variant='link'>
              Export View
            </Button>
          </li>
          {props.totalCount > 1000 && (
            <li>
              <Button onClick={() => handleExportClick(EXPORT_VIEW_COMPLETE)} variant='link'>
                Export All
              </Button>
            </li>
          )}
        </ul>
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.csvExport.errorMessage,
  results: state.csvExport.results,
  isFetching: state.csvExport.isFetching,
  aria_expanded: ownProps.aria_expanded,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchCSVDataset,
      resetCSVExport,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CSVExport))
